import { returnHostUrl } from './axiosHelper';

const getScsEnvironment = () => {
  return [returnHostUrl().spectrumPortalsHost, returnHostUrl().smbPortalsHost];
};

const send = (dataToBePassed, eventOrigin) => {
  window.parent.postMessage(dataToBePassed, eventOrigin);
};

const initReceiver = () => {
  window.addEventListener(
    'message',
    event => {
      if (!getScsEnvironment().includes(event.origin)) {
        // eslint-disable-next-line no-console
        console.error(`Cross domain redirect - Unable to match current domain url with event origin url`);
        return;
      }

      // pass local storage info here
      if (event.data === 'authRequest') {
        const dataToBePassed = {
          action: 'authResponse',
          nonce: localStorage.getItem('centralized_authentication_nonce'),
          codeVerifier: localStorage.getItem('centralized_authentication_codeVerifier'),
          xsrf: localStorage.getItem('centralized_authentication_xsrf'),
        };
        send(dataToBePassed, event.origin);
      }
    },
    false
  );
};

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export { initReceiver, inIframe };
